<script>
    export let title = '더보기';
    export let link = '#';

    const goLink = (e) => {
        console.log({link})
        e.preventDefault();
    }
</script>

<div class="more">
    <button class="more__btn" on:click={goLink}>{title}</button>
</div>

<style>
    .more {
        margin-top: 20px;
    }
    .more__btn {
        width: 100%;
        background: var(--color-primary);
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-weight: 600;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .more__btn::after {
        content:'';
        background: url('/images/common-arrow-right.svg') center center no-repeat;
        background-size: 20px auto;
        width: 20px;
        height: 20px;
        display: block;
        margin-left: 5px;
    }
</style>